var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3436",
    "data-name": "Grupo 3436",
    transform: "translate(21632 14072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_18",
    "data-name": "Subtra\\xE7\\xE3o 18",
    d: "M41,46H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H41a5.006,5.006,0,0,1,5,5V41A5.005,5.005,0,0,1,41,46ZM29.665,22.936c3.88,0,3.88,3.679,3.88,6.365V41H41V27.8c0-5.939-1.083-11.434-8.942-11.434A7.881,7.881,0,0,0,25,20.244h-.1V16.965H17.734V41h7.456V29.1C25.189,26.052,25.721,22.936,29.665,22.936ZM5.594,16.965V41h7.464V16.965ZM9.322,5a4.343,4.343,0,1,0,4.323,4.323A4.327,4.327,0,0,0,9.322,5Z",
    transform: "translate(-21632 -14072)",
    fill: "#0092f6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon2);
export default __webpack_public_path__ + "static/media/linkedin_icon2.c99f6dc9743d2e5115d18d4c82af0b75.svg";
export { ForwardRef as ReactComponent };